<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post20-stratotanker-mission-04-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post20-stratotanker-mission-04-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.92974911042096;"
    data-aspect-ratio="0.93"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post20-stratotanker-mission-04-xs-img"
      class="g-post20-stratotanker-mission-04-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-mission-04-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:15.4012%;margin-top:-9.7px;left:50.0003%;margin-left:-54.5px;width:109px;"
    >
      <p class="g-pstyle1">Fuel transfer</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs"
      style="top:18.8767%;left:50.001%;margin-left:-29.5455%;width:59.0909%;"
    >
      <p class="g-pstyle2">
        Fuel flows from the KC‑135 while the fighter maintains precise position.
      </p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs"
      style="top:72.6895%;left:33.8475%;width:59.0909%;"
    >
      <p class="g-pstyle3">
        The boom operator sits at the rear of the aircraft, guiding the
        refueling boom during in‑flight fuel transfers.
      </p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:8.0759%;margin-top:-9.7px;left:49.9737%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle0">5</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post20-stratotanker-mission-04-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.40814737322812;"
    data-aspect-ratio="1.408"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post20-stratotanker-mission-04-sm-img"
      class="g-post20-stratotanker-mission-04-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-mission-04-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs"
      style="top:46.1099%;left:54.4668%;width:38.2353%;"
    >
      <p class="g-pstyle1">
        The boom operator sits at the rear of the aircraft, guiding the
        refueling boom during in‑flight fuel transfers.
      </p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:58.7181%;margin-top:-9.7px;left:29.6247%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle2">5</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:65.8969%;margin-top:-9.7px;right:68.7432%;width:109px;"
    >
      <p class="g-pstyle3">Fuel transfer</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs"
      style="top:69.3029%;right:68.829%;width:23.5294%;"
    >
      <p class="g-pstyle4">
        Fuel flows from the KC‑135 while the fighter maintains precise position.
      </p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:30.8313%;margin-top:-9.7px;right:48.2625%;width:51px;"
    >
      <p class="g-pstyle0">Fuel</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post20-stratotanker-mission-04-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.88971915190887;"
    data-aspect-ratio="1.89"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post20-stratotanker-mission-04-md-img"
      class="g-post20-stratotanker-mission-04-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-mission-04-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:22.5232%;margin-top:-9.7px;right:79.6406%;width:109px;"
    >
      <p class="g-pstyle1">Fuel transfer</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs"
      style="top:25.7689%;right:79.7069%;width:18.1818%;"
    >
      <p class="g-pstyle2">
        Fuel flows from the KC‑135 while the fighter maintains precise position.
      </p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:43.9973%;margin-top:-9.7px;right:49.7776%;width:51px;"
    >
      <p class="g-pstyle3">Fuel</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs"
      style="top:61.2727%;left:52.6963%;width:29.5455%;"
    >
      <p class="g-pstyle4">
        The boom operator sits at the rear of the aircraft, guiding the
        refueling boom during in‑flight fuel transfers.
      </p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:14.7925%;margin-top:-9.7px;left:19.0983%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle0">5</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post20-stratotanker-mission-04-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 2.67707234005396;"
    data-aspect-ratio="2.677"
    data-min-width="930"
  >
    <div
      id="g-post20-stratotanker-mission-04-lg-img"
      class="g-post20-stratotanker-mission-04-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-mission-04-lg.jpg);"
    ></div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:41.0669%;margin-top:-9.7px;right:74.1608%;width:109px;"
    >
      <p class="g-pstyle1">Fuel transfer</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs"
      style="top:44.33%;right:74.1494%;width:19.6774%;"
    >
      <p class="g-pstyle2">
        Fuel flows from the KC‑135 while the fighter maintains precise position.
      </p>
    </div>
    <div
      id="g-ai3-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.6876%;margin-top:-9.7px;right:44.9371%;width:51px;"
    >
      <p class="g-pstyle3">Fuel</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-text g-aiAbs"
      style="top:65.0557%;left:54.7643%;width:20.9677%;"
    >
      <p class="g-pstyle4">
        The boom operator sits at the rear of the aircraft, guiding the
        refueling boom during in‑flight fuel transfers.
      </p>
    </div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:33.5826%;margin-top:-9.7px;left:24.9441%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle0">5</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-18 12:24 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-18 12:24 -->
<!-- ai file: post20-stratotanker-mission-04.ai -->
<style lang="scss">
  #g-post20-stratotanker-mission-04-box {
    container-type: inline-size;
    container-name: g-post20-stratotanker-mission-04-box;
  }
  #g-post20-stratotanker-mission-04-box,
  #g-post20-stratotanker-mission-04-box .g-artboard {
    margin: 0 auto;
  }
  #g-post20-stratotanker-mission-04-box p {
    margin: 0;
  }
  #g-post20-stratotanker-mission-04-box .g-aiAbs {
    position: absolute;
  }
  #g-post20-stratotanker-mission-04-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post20-stratotanker-mission-04-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post20-stratotanker-mission-04-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post20-stratotanker-mission-04-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post20-stratotanker-mission-04-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post20-stratotanker-mission-04-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post20-stratotanker-mission-04-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post20-stratotanker-mission-04-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-post20-stratotanker-mission-04-lg {
        display: block !important;
      }
    }
  }
  #g-post20-stratotanker-mission-04-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-mission-04-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-mission-04-xs .g-pstyle0 {
    font-weight: 700;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-04-xs .g-pstyle1 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-04-xs .g-pstyle2 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-04-xs .g-pstyle3 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-04-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-mission-04-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-mission-04-sm .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-04-sm .g-pstyle1 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-04-sm .g-pstyle2 {
    font-weight: 700;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-04-sm .g-pstyle3 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-04-sm .g-pstyle4 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-04-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-mission-04-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-mission-04-md .g-pstyle0 {
    font-weight: 700;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-04-md .g-pstyle1 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-04-md .g-pstyle2 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-04-md .g-pstyle3 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-04-md .g-pstyle4 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-04-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-mission-04-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-mission-04-lg .g-pstyle0 {
    font-weight: 700;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-04-lg .g-pstyle1 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-04-lg .g-pstyle2 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-04-lg .g-pstyle3 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-04-lg .g-pstyle4 {
    font-weight: 300;
    padding-bottom: 9px;
  }

  /* Custom CSS */
</style>
